import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {LeftDivModule} from '../leftdiv/left-div.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonSectionsModule} from '../views/common/common-sections.module';
import {ResidenceInfoComponent} from '../residence-info/residence-info.component';
import {EmailVerificationModule} from '../email-verification/email-verification.module';
import {MatButtonModule, MatFormFieldModule, MatInputModule, MatProgressSpinnerModule, MatSelectModule} from '@angular/material';
import {InvestmentApplicationFlowComponent} from '../views/investors/investment-application-flow/investment-application-flow.component';
import {ButtonModule} from '../views/common/button/button.module';

@NgModule({
    declarations: [
        ResidenceInfoComponent,
        InvestmentApplicationFlowComponent
    ],
    imports: [
        CommonSectionsModule, LeftDivModule, FormsModule, ReactiveFormsModule, MatButtonModule, MatFormFieldModule, MatInputModule, MatProgressSpinnerModule,
        MatSelectModule, RouterModule, CommonModule, EmailVerificationModule, ButtonModule]
})
export class CommonApplicationFlowModule {
}
